import { Button, Space, theme } from 'antd'

const FloatingFormControlActions = ({
  text,
  formResetAction,
  formSaveAction,
  show,
  saveActionText,
  hideReset,
  hideSave,
  prevActionText,
  hidePrev,
  formPrevAction
}) => {
  const { token } = theme.useToken()
  return (
    <div
      style={{
        transition: 'all 600ms ease',
        position: 'fixed',
        bottom: show ? 20 : -300,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        pointerEvents: show ? 'auto' : 'none'
      }}
    >
      <div
        style={{
          width: 'auto',
          minWidth: 400,
          maxWidth: '90vw',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '2px solid rgba(255, 193, 7, 0.8)',
          padding: '16px 24px',
          borderRadius: 16,
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
          gap: 16
        }}
      >
        <div
          style={{
            color: 'rgba(0, 0, 0, 0.85)',
            fontSize: '14px',
            fontWeight: 500,
            flex: 1
          }}
        >
          {text || 'You have unsaved changes, please save or reset.'}
        </div>
        <Space style={{ gap: 16 }}>
          {!hideReset && (
            <div
              onClick={formResetAction}
              style={{
                cursor: 'pointer',
                color: token.colorError,
                fontSize: '14px',
                fontWeight: 500,
                padding: '4px 8px',
                borderRadius: 6,
                transition: 'all 0.2s ease',
                ':hover': {
                  background: 'rgba(255, 77, 79, 0.1)'
                }
              }}
            >
              Reset
            </div>
          )}
          {!hidePrev && (
            <Button onClick={formPrevAction} size='large'>
              {prevActionText}
            </Button>
          )}
          <Button
            style={{
              backgroundColor: token.colorSuccess,
              color: 'white',
              border: 'none',
              borderRadius: 8,
              fontWeight: 500,
              boxShadow: '0 2px 8px rgba(82, 196, 26, 0.3)'
            }}
            onClick={formSaveAction}
            size='large'
          >
            {saveActionText}
          </Button>
        </Space>
      </div>
    </div>
  )
}

export default FloatingFormControlActions
